module.exports = __webpack_public_path__ + "static/img/8-14.c88cc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/8-14.png
// module id = 5G+h
// module chunks = 1